<template>
  <button
    data-testid="modal-close-button"
    role="button"
    class="modal-close-button"
    :class="{'close-background': !filledCloseIcon}"
    v-on="$attrs"
  >
    <IconCloseFilled
      v-if="filledCloseIcon"
    />
    <IconCloseCircle
      v-else-if="closeCircle"
    />
    <IconClose v-else />
  </button>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue'
import IconCloseFilled from '@/components/icons/IconCloseFilled.vue'
import IconCloseCircle from '@/components/icons/IconCloseCircle.vue'

export default {
  name: 'ModalCloseBtn',
  components: { IconCloseFilled, IconClose, IconCloseCircle },
  props: {
    filledCloseIcon: {
      type: Boolean,
      default: false
    },
    closeCircle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style
  scoped
  lang="scss"
>
.modal-close-button {
  position: absolute;
  padding: 0;
  border: 0;
  width: var(--space-40);
  height: var(--space-40);
  cursor: pointer;
  right: var(--space-32);
  top: var(--space-32);
  color: var(--color-zinc-700);
  z-index: 1;
  border-radius: var(--space-40);
  display: grid;
  place-items: center;
}

.close-background {
  background-color: var(--color-zinc-50);
}
</style>
